import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UserBluechatConfiguration } from '../../search/bluechat-search.component';
import { BluechatNoteModalDelivery } from '../../models/BluechatNoteModalDelivery';

@Component({
  selector: 'app-bluechat-carrier-delivery-list',
  templateUrl: './bluechat-carrier-delivery-list.component.html',
  styleUrls: ['./bluechat-carrier-delivery-list.component.scss']
})
export class BluechatCarrierDeliveryListComponent implements OnChanges {

  @Input() public deliveries: BluechatNoteModalDelivery[];
  @Input() public userBluechatConfig: UserBluechatConfiguration = { assignedCompanies: [], assignedProcesses: [], };
  @Input() public displayListCarrierName = true;

  @Output() public deleteCarrier = new EventEmitter<string>()

  public carrierWithDeliveries: CarrierWithDeliveries[];
  public showDeliveries: { [carrierBlueyonderCode: string]: boolean };

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('deliveries') && this.displayListCarrierName) {
      this.showDeliveries = {};
      this.carrierWithDeliveries = this.getCarrierWithDeliveries(this.deliveries);
      this.carrierWithDeliveries.forEach(carrier => this.showDeliveries[carrier.blueyonderCarrierCode] = true);
    }
  }

  private getCarrierWithDeliveries(deliveries: BluechatNoteModalDelivery[]) {
    const carriers: CarrierCodeAndName[] = this.getCarriers(deliveries);

    return carriers.map(carrier => {
      const res: CarrierWithDeliveries = {
        blueyonderCarrierCode: carrier.blueyonderCarrierCode,
        bluechatCarrierCode: carrier.bluechatCarrierCode,
        noteCreationAllowed: this.userBluechatConfig.assignedCompanies.some(c => c.code === carrier.bluechatCarrierCode),
        carrierName: carrier.carrierName,
        deliveryNumbers: this.getDeliveries(carrier.blueyonderCarrierCode, this.deliveries),
      };

      return res;
    });
  }

  private getDeliveries(carrierCode: string, deliveries: BluechatNoteModalDelivery[]): string[] {
    return deliveries.filter(delivery => delivery.carrierBlueyonderCode === carrierCode)
      .map(el => el.deliveryNumber);
  }

  private getCarriers(deliveries: BluechatNoteModalDelivery[]): CarrierCodeAndName[] {
    return this.distinctCarrierCodeAndName(deliveries.map(delivery => {
      return {
        blueyonderCarrierCode: delivery.carrierBlueyonderCode,
        bluechatCarrierCode: delivery.carrierBluechatCode,
        carrierName: delivery.carrierName,
      }
    }));
  }

  private distinctCarrierCodeAndName(carrierCodesAndNames: CarrierCodeAndName[]) {
    const carrierCodeAndNamesCarrierCode = carrierCodesAndNames.map(el => el.blueyonderCarrierCode);
    return carrierCodesAndNames.filter((el, index) => carrierCodeAndNamesCarrierCode.indexOf(el.blueyonderCarrierCode) === index);
  }
}

export interface CarrierWithDeliveries {
  carrierName: string;
  blueyonderCarrierCode: string;
  bluechatCarrierCode: string;
  noteCreationAllowed: boolean;
  deliveryNumbers: string[];
}

export interface  CarrierCodeAndName {
  blueyonderCarrierCode: string;
  bluechatCarrierCode: string;
  carrierName: string;
}

